'use client';

import { useContext, useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { Contents } from 'components/ring-air/Contents';
import { RingProSelectionContext } from 'components/ring-pro/RingProSelectionContext';
import {
  RingProColors,
  RingProChargerCaseColor,
  RING_COLOR_TO_CHARGER_MAP,
} from 'content/products/ring-pro';

const RING_COLOR_SLUG: Record<RingProColors, string> = {
  [RingProColors.GOLD]: 'gold',
  [RingProColors.SILVER]: 'silver',
  [RingProColors.BLACK]: 'black',
  [RingProColors.TITANIUM]: 'titanium',
};

const BOX_CONTENTS_BASE = 'web_v2/ring-pro/buy-v2/box-contents';

export function RingProContents() {
  const t = useTranslations('ring');
  const tRingPro = useTranslations('ring-pro');
  const { color } = useContext(RingProSelectionContext);

  const contentData = useMemo(() => {
    const ringColor = color ?? RingProColors.GOLD;
    const chargerColor = RING_COLOR_TO_CHARGER_MAP[ringColor];
    const ringSlug = RING_COLOR_SLUG[ringColor];
    const chargerSlug =
      chargerColor === RingProChargerCaseColor.GOLD ? 'gold' : 'black';

    return [
      {
        image: `${BOX_CONTENTS_BASE}/r-${ringSlug}.png/w_800`,
        title: tRingPro('ring-pro.contents.data.Ring'),
      },
      {
        image: `${BOX_CONTENTS_BASE}/c-${chargerSlug}.png/w_800`,
        title: tRingPro('ring-pro.contents.data.Charger'),
      },
      {
        image: `${BOX_CONTENTS_BASE}/cable-1.png/w_800`,
        title: t('ring.contents.data.Cable'),
      },
    ];
  }, [color, t, tRingPro]);

  return <Contents htmlId="ring-pro-contents" contentData={contentData} />;
}
